/**
 * 黑名单页懒加载壳（14.22b-2；FriendGroupsLazy 同构）：低频管理页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function BlacklistLazy() {
  const { mod } = useLazyModule(() => import('./BlacklistPage'));
  if (mod === null) return <div data-testid="blacklist-loading-shell">加载中…</div>;
  return <mod.BlacklistPage />;
}
